<div class="snackBarContainer">
    <mat-icon style="margin-left:10px; margin-right:14px;" class="vertCenter">check_circle</mat-icon>
    <h3 class="vertCenter">{{data.message}}</h3>
    <button mat-button (click)="snackBar.dismiss()" class="vertCenter">
        <mat-icon class="iconCenter">close</mat-icon>
    </button>
</div>